import React, { useState, useEffect } from 'react';
// import './Spinner.css'; // Create a CSS file for the styles
import './App.css'; // Import the CSS file

const Preloader = ({ compact = false, inline = false }) => {
  const [counter, setCounter] = useState(0);

  useEffect(() => {
    // Increment the counter from 0 to 100
    let intervalId = setInterval(() => {
      setCounter((prevCounter) => {
        if (prevCounter < 100) {
          return prevCounter + 1;
        } else {
          clearInterval(intervalId);
          return 100;
        }
      });
    }, 100); // Adjust the interval time as needed

    return () => clearInterval(intervalId); // Cleanup on unmount
  }, []);

  return (
    <div className={`spinner-container${compact ? ' spinner-container--compact' : ''}${inline ? ' spinner-container--inline' : ''}`}>
      <div className="spinner big-spinner">
        <svg width="100" height="100" viewBox="0 0 89 89" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M85.3438 44.5C87.3631 44.5 89.0156 46.1398 88.8499 48.1523C88.2312 55.666 85.7111 62.9211 81.5004 69.2229C76.6107 76.5409 69.6607 82.2445 61.5294 85.6126C53.3981 88.9807 44.4506 89.862 35.8185 88.1449C27.1863 86.4279 19.2572 82.1897 13.0337 75.9663C6.81031 69.7428 2.5721 61.8137 0.855055 53.1815C-0.861987 44.5494 0.0192612 35.6019 3.38736 27.4706C6.75546 19.3393 12.4591 12.3893 19.7771 7.4996C26.0789 3.2889 33.334 0.768814 40.8477 0.150102C42.8602 -0.0156122 44.5 1.63694 44.5 3.65622C44.5 5.67549 42.8591 7.2938 40.8496 7.49201C34.7841 8.09028 28.9385 10.1728 23.8397 13.5797C17.7242 17.6659 12.9578 23.4738 10.1432 30.2689C7.32853 37.0641 6.59209 44.5413 8.02698 51.7549C9.46187 58.9686 13.0036 65.5948 18.2044 70.7956C23.4052 75.9964 30.0314 79.5381 37.2451 80.973C44.4587 82.4079 51.9359 81.6715 58.7311 78.8568C65.5262 76.0422 71.3341 71.2758 75.4203 65.1603C78.8272 60.0615 80.9097 54.2159 81.508 48.1504C81.7062 46.1409 83.3245 44.5 85.3438 44.5Z"
            fill="#0FB8B4"
          />
        </svg>
      </div>
      <div className="spinner small-spinner">
        <svg width="80" height="80" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M3.61522 35.5C1.61859 35.5 -0.0190795 33.8772 0.183887 31.8909C0.854869 25.3245 3.34706 19.0489 7.413 13.7889C12.2188 7.57182 18.9515 3.12491 26.5561 1.14515C34.1606 -0.834614 42.2071 -0.235325 49.4344 2.84909C56.6618 5.93351 62.6615 11.3287 66.4933 18.1891C70.3251 25.0496 71.7724 32.9875 70.6083 40.7588C69.4443 48.5301 65.7347 55.6956 60.061 61.1322C54.3872 66.5688 47.07 69.9693 39.2561 70.8007C32.6452 71.5042 25.9948 70.335 20.052 67.4627C18.2543 66.5938 17.7314 64.3484 18.7785 62.6483C19.8256 60.9483 22.0457 60.4427 23.8654 61.2644C28.4257 63.3238 33.4726 64.1449 38.4911 63.6109C44.7135 62.9488 50.5404 60.2409 55.0585 55.9116C59.5767 51.5823 62.5307 45.8762 63.4577 39.6877C64.3846 33.4992 63.2321 27.1781 60.1808 21.7149C57.1294 16.2518 52.3517 11.9554 46.5963 9.49925C40.841 7.04305 34.4334 6.56582 28.3777 8.14235C22.322 9.71889 16.9606 13.2601 13.1336 18.2109C10.0471 22.2039 8.09942 26.9317 7.46127 31.8945C7.20662 33.8748 5.61185 35.5 3.61522 35.5Z"
            fill="#0055A2"
          />
        </svg>
      </div>
      <div className="counter">{counter}%</div>
    </div>
  );
};

export default Preloader;
